<template>
<div class="d-flex justify-content-between">
    <div></div>
    <div class="table-btn-group d-flex align-items-center">

    <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
</div>
</div>
<div class="search-wrap">
    <div class="row">
    <div class="col-md-3">
        <div class="mb-3">
            <ElLabel name="기준일">
                <template #end="{id}">
                <div class="d-flex justify-content-between" :id="id">
                    <DatePicker :select-date="state.searchParams.start_dt" @return="r => state.searchParams.start_dt = r" />
                </div>
                </template>
            </ElLabel>
        </div>
    </div>
    <div class="col-md-3">
        <div class="mb-3">
            <ElLabel name="회계년도">
            <template #end>
                <DatePicker v-model="state.searchParams.fiscal_year" :format="state.format" :year-picker="true"  @return="r => state.searchParams.fiscal_year = r" :selectDate="state.searchParams.fiscal_year"/>
            </template>
            </ElLabel>
        </div>
    </div>
    </div>
</div>
    <div class="search-detail-wrap"></div>

<div class="text-end py-2">
    <ElButton type="search" @buttonClick="searchTypeSalesId()">검색</ElButton>
</div>
<div class="table-responsive table-list">
    <DataTable
        :value="state.typeSalesIdList"
        paginator :rows="50" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        scrollable scrollHeight="600px" removableSort
        stripedRows>
        <template #empty>
            <div>데이터가 존재하지 않습니다.</div>
        </template> 
        <Column v-for="(opty,index) of state.salesGrid" :key="index" :field="opty.field" :header="opty.header" :class="opty.class ||''"
        :style="opty.style" sortable :frozen="opty.frozen">
            <template #body="{ data, field}">
                <span v-if="opty.field == 'stage'" :class="getOptionStyle(data.stage)">{{ data.stage }}</span>
                <div v-else-if="opty.field.includes('sum')" class="bg-light">{{ priceToString(data[field])}}</div>
                <div v-else-if="opty.field === 'gmamt'">{{ priceToString(data[field])}}</div>
                <div v-else-if="opty.field === 'sales_ceo' || opty.field === 'bnr_nm'|| opty.field ==='tax_yn'" class="elip-div" style="text-align: center;">
                    {{ data[field] }}
                </div>
                <div v-else class="elip-div2" :title="data[field]">{{ data[field] }}</div>
            </template>
        </Column>
    </DataTable>
</div>
<div><ExcelManage
      ref="excelUtilRef"
      v-show="false">
     </ExcelManage>
     </div>
</template>
<script setup>
import {reactive,ref,onBeforeMount} from 'vue';
import DatePicker     from '@/components/common/DatePicker';
import common         from '@/js/common';
import DataTable      from 'primevue/datatable';
import Column         from 'primevue/column';
import ExcelManage    from '@/components/common/MCO_EX_003.vue'
import { typeSalesId, typeSalesIdExcel } from "@/api/batch.js";
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading();
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useSearchBatchListStore } from "@/store/batchList";
const batchParams = useSearchBatchListStore()

const excelUtilRef = ref()
const yearsList = ref([]);
// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date();
var startStr = dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
var endStr = dt.getFullYear() + '-' + String(dt.getMonth() + 2).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');


onBeforeMount(async() => {
    if(batchParams.searchParams.fiscal_year){
        state.searchParams.fiscal_year = batchParams.searchParams.fiscal_year;
    }else{
        getYearsList()
    }

    if(batchParams.searchParams.start_dt){
        state.searchParams.start_dt = batchParams.searchParams.start_dt;
    }else{
        state.searchParams.start_dt = startStr;
        state.searchParams.end_dt = endStr;
    }
    await searchTypeSalesId();
});

//변수 선언 영역 
const state = reactive({
    gridRowData :[],  
    salesGrid:[
        { header: "영업기회ID", field: "sales_id", style: { minWidth: '120px' ,maxWidth: '130px',fontSize: '12px'},frozen:true  },
        { header: "End User", field: "end_user_cmp_nm", style: { maxWidth: '120px' ,fontSize: '12px'},frozen:true  },
        { header: "영업기회명", field: "sales_nm", style: {minWidth: '170px' , maxWidth: '170px' ,fontSize: '12px'} ,frozen:true },
        { header: "매출금액", field: "outcome_sum", style: { minWidth: '100px' ,textAlign: 'right' ,fontSize: '12px'}, class:"bg-light" },
        { header: "매입금액", field: "income_sum", style: { minWidth: '100px' ,textAlign: 'right'  ,fontSize: '12px'}, class:"bg-light" },
        { header: "GM Amount", field: "gmamt", style: { textAlign: 'right',fontSize: '12px'}, class:"bg-red" },
        { header: "매출세금계산서발행일", field: "tax_dt", style: { minWidth: '110px' , maxWidth: '115px',textAlign: 'center',fontSize: '12px'}},
        { header: "발행여부", field: "tax_yn", style: { minWidth: '70px' , maxWidth: '70px',textAlign: 'center',fontSize: '12px'} },
        { header: "Stage", field: "stage", style: { maxWidth: '85px',textAlign: 'center',fontSize: '12px'} },
        { header: "영업대표", field: "sales_ceo", style: { minWidth: '70px',textAlign: 'center',fontSize: '12px'} },
        { header: "Bridge(B) Risk(R)", field: "bnr_nm", style: { minWidth: '100px',textAlign: 'center',fontSize: '12px'} },
        { header: "매출처", field: "sales_cmp_nm", style: { minWidth: '100px',fontSize: '12px'} },
        { header: "제조사", field: "maker_cmp_nm", style: { minWidth: '100px',fontSize: '12px'} }
    ],
    excelCol: [
        { header: "기준일", field: "start_dt"}, 
        { header: "회계년도", field: "fiscal_year"}, 
        { header: "영업기회ID", field: "sales_id"},
        { header: "End User", field: "end_user_cmp_nm"},
        { header: "매출처", field: "sales_cmp_nm"},
        { header: "영업기회", field: "sales_nm"},
        { header: "회사분류", field: "company_nm"},
        { header: "상품별", field: "prod_nm"},
        { header: "제조사", field: "maker_cmp_nm"},
        { header: "매입처", field: "buy_cmp_nm"},
        { header: "매출금액", field: "outcome_sum"},
        { header: "매입금액", field: "income_sum"},
        { header: "FCST ABC", field: "fcstabc"},
        { header: "GM Amount", field: "gmamt"},
        { header: "매출세금계산서발행일", field: "tax_dt"},
        { header: "발행여부", field: "tax_yn"},
        { header: "수금일", field: "collect_dt"},
        { header: "수금여부", field: "collect_yn"},
        { header: "매입세금계산서발행일", field: "tax_sale_dt"},
        { header: "매입여부", field: "tax_sale_yn"},
        { header: "지급일", field: "pay_dt"},
        { header: "지급여부", field: "pay_yn"},
        { header: "Stage", field: "stage"},
        { header: "Bridge(B)/Risk(R)", field: "bnr_nm"},
        { header: "우선협상선정일", field: "won_dt"},
        { header: "po발생일", field: "po_dt"},
        { header: "영업대표", field: "sales_ceo"},

    ],
    searchParams: {
        fiscal_year:'',
        start_dt:'',
        employee_id : userStore.user.employeeId,
        auth_grp_id : userStore.user.authGrpId
    },            
    typeSalesIdList :[],
    yearList: [],
    format:'yyyy'
});

function getYearsList() {
  const prevYear = new Date().getFullYear() - 3;   
  const currYear = new Date().getFullYear();    
  for (let i = currYear; i >= prevYear; i--) {
    yearsList.value = [...yearsList.value, i];  
  }
  state.searchParams.fiscal_year = yearsList.value[0];

}

const priceToString = (item) => {
    return common.checkNumberComma(item)
}


const getOptionStyle = (item) => {
        const stageValue = item
        let classNm = ''
        if (stageValue == 'Pipeline') {
            classNm = 'stage stage-pipeline';
        } else if (stageValue == 'Upside') {
            classNm = 'stage stage-upside';
        } else if (stageValue == 'Commit') {
            classNm = 'stage stage-commit';
        } else if (stageValue == 'Won') {
            classNm = 'stage stage-won';
        } else if (stageValue == 'Close') {
            classNm = 'stage stage-close';
        } else if (stageValue == 'Omit') {
            classNm = 'stage stage-omit';
        } else if (stageValue == 'Lost') {
            classNm = 'stage stage-lost';
        } 
        return classNm
    }

    //엑셀 다운로드
const excelDown = async () =>{
    let fileNm = '영업기회별 배치 결과 조회 ' + '_' + state.searchParams.fiscal_year + ' ' +state.searchParams.start_dt 
    let header = [...state.excelCol];
    try{
        setIsLoading(true)
        if(state.searchParams.start_dt){

        }
        const res = await typeSalesIdExcel(state.searchParams)
        let dataList = [...res.rtn].map((item,index)=>{
            item.index = (index+1)
            Object.keys(item).forEach((key)=>{
            if(key === 'fcstabc' || key === 'gmamt'){
                item[key] = isNaN(Number(item[key])) ? item[key] : Number(item[key])
            }
        })
        return item
    })
        excelUtilRef.value.excelDownload(fileNm, header, dataList);
    }catch(e){
        console.log(e)
    }finally{
        setIsLoading(false)
    }
}

const searchTypeSalesId = async () => {
    try {
        setIsLoading(true)
        batchParams.searchParamsData(state.searchParams)
        const res = await typeSalesId(state.searchParams)
        state.typeSalesIdList = [...res.rtn]
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
};
                                            
</script>